import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from './../styles.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { rect } from '#utilities/js/fixed/fixed.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'

const onClick = object(tapUp, {
  capture,
  passive,
  task: (
    button
  ) => {
    const { ariaExpanded } = button
    const container = closest(`.${elements.rte_actions}`, button)

    if (container) {
      const advanced = one(`.${elements.rte_advanced_actions}`, container)
      const rte = closest(`.${elements.rte}`, container)
      const { style } = rte
      const actionsStickyBottom = getComputedStyle(container).getPropertyValue('--ea_rte_actions_sticky_bottom')

      button.setAttribute('aria-expanded', `${!Boolean(ariaExpanded === 'true')}`)
      advanced.classList.toggle(utilities.modifiers.display.none)

      if (rte && actionsStickyBottom === 'true') {
        const { height } = rect(container)

        style.setProperty('--ea_rte_actions_height', `${height}px`)
      }
    }
  }
})

export default button => {
  onClick.listen(button)
}
